import React, { useContext, useEffect, useRef, useState } from 'react';
import GlobalContext from './GlobalContext';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import ProgressBar from './ProgressBar';
import { Box,  CircularProgress, Typography, Select,MenuItem, Button  } from '@mui/material';
import ConsoleLog   from './ConsoleLog';
import LockDialog from './LockDialog';
import NoteDialog from './NoteDialog';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faEnvelope, faCheck, faTableCellsRowUnlock } from '@fortawesome/free-solid-svg-icons'


const GoalsDataGrid = ({ token,isLoading,  goalsDetails, treeNode, salesGoalID, refresh, refreshSilent, refreshTree }) => {
    const {year, API_URL, roleLevels, goalStatus, displayCurrency, displayPct } = useContext(GlobalContext);
    const apiRef = useGridApiRef();
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [distinctBrands, setDistinctBrands] = useState(null);
    const [distinctCategories, setDistinctCategories] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState("ALL BRANDS");
    const [selectedCategory, setSelectedCategory] = useState("ALL CATEGORIES");
   
    const [editView, setEditView] = useState(false);
     
    const [status, setStatus] = useState("");
    const [role, setRole] = useState("");
    const [columns, setColumns] = useState ([]);

    const [progress, setProgress] = useState(null);
    const pendingRestoreRef = useRef(null);
    const gridContainerRef = useRef(null);
    const lastValuesRef = useRef({}); // cache last non-null values per row/field to avoid flicker

    const getScrollParent = (node) => {
        if (!node) return null;
        const isScrollable = (el) => {
            const style = window.getComputedStyle(el);
            const overflowY = style.overflowY;
            const overflowX = style.overflowX;
            const canScrollY = (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
            const canScrollX = (overflowX === 'auto' || overflowX === 'scroll') && el.scrollWidth > el.clientWidth;
            return canScrollY || canScrollX;
        };
        let current = node;
        while (current && current !== document.body && current !== document.documentElement) {
            if (isScrollable(current)) return current;
            current = current.parentElement;
        }
        return document.scrollingElement || document.documentElement || document.body;
    };
    
    const getRowKey = (row) => `${row.salesGoalID}|${row.brand}|${row.category}`;

    const renderCurrencyCell = (fieldName) => (params) => {
        const row = params.row || {};
        const key = getRowKey(row);
        let value = row[fieldName];
        if (value === null || value === undefined || Number.isNaN(value)) {
            const cached = lastValuesRef.current[key]?.[fieldName];
            if (cached !== undefined && cached !== null) value = cached;
        } else {
            lastValuesRef.current[key] = {
                ...(lastValuesRef.current[key] || {}),
                [fieldName]: value
            };
        }
        return displayCurrency(value ?? 0);
    };

    const renderPctCell = (fieldName) => (params) => {
        const row = params.row || {};
        const key = getRowKey(row);
        let value = row[fieldName];
        if (value === null || value === undefined || Number.isNaN(Number(value))) {
            const cached = lastValuesRef.current[key]?.[fieldName];
            if (cached !== undefined && cached !== null) value = cached;
        } else {
            lastValuesRef.current[key] = {
                ...(lastValuesRef.current[key] || {}),
                [fieldName]: Number(value)
            };
        }
        return displayPct(Number(value ?? 0));
    };
    

    useEffect(() => {
        
        var r = goalsDetails[0]?.roleName;
        var s = goalsDetails[1]?.status;
        
        setStatus(s);
        setRole(r);

        setData(goalsDetails);
        setFilteredData(goalsDetails);

        setEditView(salesGoalID.length !== 0 && ((s === goalStatus.Level1 && r=== roleLevels.Level1) || (s === goalStatus.Level2 && r === roleLevels.Level2) || (s === goalStatus.Level3 && r === roleLevels.Level3)));
        setDistinctBrands(getUniqueBrands(goalsDetails));
        setDistinctCategories(getUniqueCategories(goalsDetails));
       
        const cols = [
            { field: 'brand', headerName: 'Brand',  hideable:false, editable:false, sortable: false , width: "120"},
            { field: 'category', headerName: 'Category',hideable:false, editable:false ,  sortable: false ,width: "170"},
            { field: 'priorActuals_3Y', headerName:  `${year-3} Actuals`, type: "number",
                valueGetter: (value, row) => displayCurrency(row.priorActuals_3Y), 
                hideable:true, editable:false, width: "120",sortable: true,
                sortComparator: (v1, v2) => {
                    return  parseInt(v1.replace(/,/g, '')) - parseInt(v2.replace(/,/g, ''))
                } ,
            },

            { field: 'priorActuals_2Y', headerName: `${year-2} Actuals`, type: "number",
                valueGetter: (value, row) => displayCurrency(row.priorActuals_2Y), 
                hideable:true, editable:false , width: "120",
                sortable: true,
                sortComparator: (v1, v2) => {
                    return  parseInt(v1.replace(/,/g, '')) - parseInt(v2.replace(/,/g, ''))
                } 
            }
            ,
            { field: 'priorActuals_2Y_Growth_PCT', headerName: 'Growth', 
              valueGetter: (value, row) => displayPct(row.priorActuals_2Y_Growth_PCT), 
              hideable:true, editable:false , width: "85",sortable: true,
              sortComparator: (v1, v2) => {
                  return  parseInt(v1.replace(/%/g, '')) - parseInt(v2.replace(/%/g, ''))
              } 
            
            },
            { field: 'priorActuals', headerName: `${year-1} Actuals YTD` , type: "number",
                valueGetter: (value, row) => displayCurrency(row.priorActuals), 
                hideable:true, editable:false ,  width: "120"},
            { field: 'priorProjected', headerName: `${year-1} Projected`,type: "number",
                valueGetter: (value, row) => displayCurrency(row.priorProjected), 
                hideable:true, editable:false ,  width: "120",
                sortable: true,
                sortComparator: (v1, v2) => {
                    return  parseInt(v1.replace(/,/g, '')) - parseInt(v2.replace(/,/g, ''))
                } 
            },
            { field: 'priorActuals_Growth_PCT', headerName: 'Growth', 
                valueGetter: (value, row) => displayPct(row.priorActuals_Growth_PCT), 
                hideable:true, editable:false , width: "85",sortable: true,
                sortComparator: (v1, v2) => {
                    return  parseInt(v1.replace(/%/g, '')) - parseInt(v2.replace(/%/g, ''))
                } 
            },
            { field: 'repGoalAmt', headerName: 'Rep Agency',  type: "number",
                renderCell: renderCurrencyCell('repGoalAmt'),
                valueParser: (val) => {
                    if (val === '' || val === null || val === undefined) return null;
                    return Number(String(val).replace(/,/g, ''));
                },
                hideable:true, editable:salesGoalID.length > 0 && r === roleLevels.Level1 && s === goalStatus.Level1, width: "120",
                sortable: true,
                sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                headerClassName: r === roleLevels.Level1 && s === goalStatus.Level1 ? "highlightYellow" :""
            },
            { field: 'rep_Growth_PCT', headerName: 'Growth', 
                renderCell: renderPctCell('rep_Growth_PCT'),
                valueParser: (val) => {
                    if (val === '' || val === null || val === undefined) return null;
                    return Number(String(val).replace(/%/g, ''));
                },
                hideable:true,  editable:salesGoalID.length > 0 && r === roleLevels.Level1 && s === goalStatus.Level1 , width: "85",
                sortable: true,
                sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                headerClassName: r === roleLevels.Level1 && s === goalStatus.Level1 ? "highlightYellow" :""
            },

            ...(r !== roleLevels.Level1 ? 
                [ 
                    {field: 'rsdGoalAmt', headerName: 'RSD', type: "number",
                      renderCell: renderCurrencyCell('rsdGoalAmt'),
                      valueParser: (val) => {
                        if (val === '' || val === null || val === undefined) return null;
                        return Number(String(val).replace(/,/g, ''));
                      },
                      hideable:true, editable:salesGoalID.length > 0 && r === roleLevels.Level2 && s === goalStatus.Level2, width: "120",
                      sortable: true,
                      sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                      headerClassName: r === roleLevels.Level2 && s === goalStatus.Level2 ? "highlightYellow" :""
                    },
                    {field: 'rsD_Growth_PCT', headerName: 'Growth', 
                      renderCell: renderPctCell('rsD_Growth_PCT'),
                      valueParser: (val) => {
                        if (val === '' || val === null || val === undefined) return null;
                        return Number(String(val).replace(/%/g, ''));
                      },
                      hideable:true,  editable:salesGoalID.length > 0 && r === roleLevels.Level2 && s === goalStatus.Level2, width: "90",
                      sortable: true,
                      sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                      headerClassName: r === roleLevels.Level2 && s === goalStatus.Level2 ? "highlightYellow" :""
                    } ,
                ]
                :[]
    
            ),
            ...(r === roleLevels.Level3 ?  
                [
                    {field: 'finalGoalAmt', headerName: 'Final', type: "number",
                      renderCell: renderCurrencyCell('finalGoalAmt'),
                      valueParser: (val) => {
                        if (val === '' || val === null || val === undefined) return null;
                        return Number(String(val).replace(/,/g, ''));
                      },
                      hideable:true,  editable:salesGoalID.length > 0 && r === roleLevels.Level3 && s === goalStatus.Level3, width: "120",
                      sortable: true,
                      sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                        headerClassName: r === roleLevels.Level3 && s === goalStatus.Level3 ? "highlightYellow" :""
                    },
                    {field: 'final_Growth_PCT', headerName: 'Growth', 
                      renderCell: renderPctCell('final_Growth_PCT'),
                      valueParser: (val) => {
                        if (val === '' || val === null || val === undefined) return null;
                        return Number(String(val).replace(/%/g, ''));
                      },
                      hideable:true,  editable:salesGoalID.length > 0 && r === roleLevels.Level3 && s === goalStatus.Level3,  width: "85",
                      sortable: true,
                      sortComparator: (v1, v2) => Number(v1 ?? 0) - Number(v2 ?? 0),
                      headerClassName: r === roleLevels.Level3 && s === goalStatus.Level3 ? "highlightYellow" :""
                    },
                      { field: 'planAmt', headerName: 'Plan', type: "number",
                        valueGetter: (value, row) => displayCurrency(row.planAmt),
                        hideable:true, editable:false, width: "120",
                        sortable: true,
                        sortComparator: (v1, v2) => {
                          return  parseInt(v1.replace(/,/g, '')) - parseInt(v2.replace(/,/g, ''))
                          }
                    }
                ]
                :[]),

                ...(((s === "LK1" && r === roleLevels.Level1) || (s==="LK2" && r === roleLevels.Level2) || s ==="LK3" && r=== roleLevels.Level3) ? 
                    [
                { 
                    field:'updated', headerName: 'Updated', 
                    renderCell: (params) => (
    
                        <div>
                            {params.value === true && (
                                <FontAwesomeIcon icon={faCheck} />
                            )}
                           
                        </div>
        
                        
                      )  
                }] : [])
          
        ];
 
        setColumns(cols);

        const total = goalsDetails.filter((sg) => sg.brand.trim() !== "" && sg.brand.trim() !== "ALL BRANDS" && sg.brand.trim() !== "SUB-TOTAL").length;
        const updatedCount = goalsDetails.filter(goal => goal.updated === true).length;
        setProgress(Math.round((updatedCount/total)*100));
        
    }, [goalsDetails,treeNode,salesGoalID]);


    const getUniqueBrands = (data) => {
        return data.reduce((uniqueBrands, item) => {
            if (!uniqueBrands.includes(item.brand) && item.brand.trim() !== "" && item.brand.trim() !=="SUB-TOTAL") {
                uniqueBrands.push(item.brand);
            }
            return uniqueBrands;
        }, []);
    };

    const getUniqueCategories = (data) => {
        return data.reduce((uniqueCats, item) => {
            if (!uniqueCats.includes(item.category) && item.category !== undefined && item.category !== null && item.category.trim() !== "" && item.category.trim() !== "GRAND TOTAL" && item.brand.trim() !=="SUB-TOTAL" ) {
                uniqueCats.push(item.category);
            }
            return uniqueCats;
        }, []);
    }

    const filterBrand = (newValue) =>
    {
        setSelectedBrand(newValue);
        setSelectedCategory("ALL CATEGORIES");
        if(newValue === "ALL BRANDS")
            return data;
        else{
            var fData = data.filter((g) => g.brand === newValue  || g.category === newValue)
            setDistinctCategories(getUniqueCategories(fData));
            return fData;
        }

    }

    const filterCategory = (newValue) =>
    {
        let fData = filterBrand(selectedBrand);
        setSelectedCategory(newValue);
   
        if(newValue === "ALL CATEGORIES" && selectedBrand === "ALL BRANDS")
            return data;
        else if(newValue === "ALL CATEGORIES")
        {
            return fData;
        }
        else{
            return fData.filter((g) => g.category === newValue );
        }
            
    }
        
    const handleLockClick = () =>
    {
        if((progress === 100 && role === roleLevels.Level1) || (role !== roleLevels.Level1))
        {
            const request = {
                token: token,
                salesGoalID: salesGoalID,
                status: getNextStatus(status)
            }
            axios.post(`${API_URL}/salesgoals/status`, request,
                {  
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((response) =>  {
                    refresh();
                    refreshTree(treeNode);
                    toast.success("All Sales Goals have been submitted.");
                })
                .catch(err => 
                    console.error(err)
                );
        }
       else{
        toast.warning("Please submit a sales goal for each brand and category listed below.");
       }
    }

    const getNextStatus = (currStatus) => {
        let nextStatus = "";
        switch(currStatus){
            case goalStatus.Level1:
                nextStatus = goalStatus.Level2;
                break;
            case goalStatus.Level2:
                nextStatus = goalStatus.Level3;
                break;
            case goalStatus.level3:
                nextStatus = goalStatus.Level4;
                break;
            default:
                nextStatus = goalStatus.Level4;
        }
        return nextStatus;
    }

    const getBackStatus = (currStatus) => {
        
        let backStatus = "";
        switch(currStatus){
            case goalStatus.Level4:
                backStatus = goalStatus.Level3;
                break;
            case goalStatus.Level3:
                backStatus = goalStatus.Level2;
                break;
            case goalStatus.Level2:
                backStatus = goalStatus.Level1;
                break;
            default:
                backStatus = goalStatus.Level4;
        }
        return backStatus;
    }

    const handleUnlockClick = () =>
    {
        const request = {
            token: token,
            salesGoalID: salesGoalID,
            status: getBackStatus(status)
        }
        axios.post(`${API_URL}/salesgoals/status`, request,
            {  
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) =>  {
                refresh();
                    refreshTree(treeNode);
                toast.success("Sales Goal has been unlocked.");
            })
            .catch(err => 
                console.error(err)
            );
    }

    const handleSaveNoteClick = (note) =>{
        var newLevel = getBackStatus(status);
        
        if(newLevel !== "")
        {
            const noteRequest = {
                salesGoalID: salesGoalID,
                note: note,
                token: token,
                newLevel: newLevel
            };

            axios.post(`${API_URL}/salesgoals/note`, noteRequest,
                {  
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((response) =>  {
                    refresh();
                    refreshTree(treeNode);
                })
                .catch(err => 
                    console.error(err)
                );
        }
        

    }

    const handleExportClick =  async () => {
        try{
            const request = {
                token: token,
                treeNode: treeNode.name,
                treeNodeDesc: treeNode.description
              };
            const response = await axios.post(`${API_URL}/salesgoals/export`, request, {
                  responseType: 'blob',
                  headers: { 'Content-Type': 'application/json'
               } 
            });
            const blob = new Blob([response.data]);
            const a = document.createElement('a');
            const downloadUrl = window.URL.createObjectURL(blob);
            a.href = downloadUrl;
    
            // Generate the filename
            const filename = `${treeNode.description}_SalesGoals_${new Date().toJSON().slice(0, 10)}.xlsx`;
            a.download = filename;
    
            // Trigger the download
            a.click();
    
            // Revoke the object URL after the download to free memory
            window.URL.revokeObjectURL(downloadUrl);
        }
        catch (error) {
            console.error('Error downloading the file:', error);
      }  


       
    }

    const updateTotals = (newAmount, goalRow) =>{
        // Capture page/container scroll (iframe-safe & scoped to this grid)
        const containerEl = gridContainerRef.current;
        const pageScroller = getScrollParent(containerEl);
        const pageScroll = { top: pageScroller?.scrollTop || 0, left: pageScroller?.scrollLeft || 0 };
        // Capture grid scroll and focused cell (apiRef first, DOM fallback)
        const gridScroll = apiRef.current?.getScrollPosition
            ? apiRef.current.getScrollPosition()
            : (() => {
                const vs = containerEl ? containerEl.querySelector('.MuiDataGrid-virtualScroller') : null;
                return vs ? { top: vs.scrollTop, left: vs.scrollLeft } : null;
            })();

        let focusedCell = null;
        try {
            focusedCell = apiRef.current?.state?.focus?.cell ?? null; // { id, field }
        } catch { /* ignore if not available */ }
    console.log("focusedCell", focusedCell);
        // Optimistically update local state for smoother UX
        const rowMatcher = (r) =>
            r.salesGoalID === goalRow.salesGoalID &&
            r.brand === goalRow.brand &&
            r.category === goalRow.category;

        setData((prev) =>
            prev.map((r) => (rowMatcher(r) ? { ...r, ...goalRow, updated: true } : r))
        );
        setFilteredData((prev) =>
            prev.map((r) => (rowMatcher(r) ? { ...r, ...goalRow, updated: true } : r))
        );


        const salesGoalRequest = {
            token: token,
            salesGoalID: goalRow.salesGoalID,
            brand: goalRow.brand,
            category: goalRow.category,
            amount: newAmount
        };
 
        
        axios.post(`${API_URL}/salesgoals/update`, salesGoalRequest,
            {  
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) =>  {
         
                if (typeof refreshSilent === 'function') {
                    refreshSilent();
                } else {
                    refresh();
                }
                 // Preserve current filter
                setFilteredData(filterBrand(selectedBrand));

                // Defer restore until data has actually reloaded
                pendingRestoreRef.current = { gridScroll, focusedCell, pageScroll };
            })
            .catch(err => 
                console.error(err)
            );
    }

    // Perform deferred restoration after data refresh completes
    useEffect(() => {
        if (!pendingRestoreRef.current) return;
        if (isLoading) return; // wait until loading completes

        const { gridScroll, focusedCell, pageScroll } = pendingRestoreRef.current;
        pendingRestoreRef.current = null;

        setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // Ensure the summary grid doesn't hold focus
                    const summaryGridRoot = document.querySelector('.goalTables .MuiDataGrid-root');
                    if (summaryGridRoot) {
                        summaryGridRoot.blur?.();
                        summaryGridRoot.setAttribute?.('tabindex', '-1');
                    }
                    // Restore grid scroll first
                    if (gridScroll) {
                        if (apiRef.current?.setScrollPosition) {
                            apiRef.current.setScrollPosition(gridScroll);
                        } else {
                            const vs = gridContainerRef.current ? gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller') : null;
                            if (vs) {
                                if (typeof gridScroll.top === 'number') vs.scrollTop = gridScroll.top;
                                if (typeof gridScroll.left === 'number') vs.scrollLeft = gridScroll.left;
                            }
                        }
                    }

                    // Restore selection/focus to the row (no edit mode) with retry
                    const attemptFocusRestore = (tries = 0) => {
                        if (!focusedCell) return;
                        const id = focusedCell.id;
                        if (apiRef.current?.selectRow) {
                            apiRef.current.selectRow(id, true, true);
                        } else if (apiRef.current?.setRowSelectionModel) {
                            apiRef.current.setRowSelectionModel([id]);
                        }
                        if (apiRef.current?.setCellFocus) {
                            apiRef.current.setCellFocus(id, 'brand');
                        } else {
                            const root = gridContainerRef.current ? gridContainerRef.current.querySelector('.MuiDataGrid-root') : null;
                            root?.focus?.();
                        }
                        const active = document.activeElement;
                        const inDetail = gridContainerRef.current && active && gridContainerRef.current.contains(active);
                        if (!inDetail && tries < 6) {
                            requestAnimationFrame(() => attemptFocusRestore(tries + 1));
                        }
                    };
                    attemptFocusRestore();

                    // Re-apply page/container scroll; run twice to neutralize focus-induced scroll
                    const scroller = getScrollParent(gridContainerRef.current) || document.scrollingElement || document.documentElement || document.body;
                    scroller.scrollTop = pageScroll.top;
                    scroller.scrollLeft = pageScroll.left;
                    requestAnimationFrame(() => {
                        scroller.scrollTop = pageScroll.top;
                        scroller.scrollLeft = pageScroll.left;
                    });
                });
            });
        }, 0);
    }, [isLoading, filteredData]);

    function isValidAmount(amt)
    {
        let num = Number(amt);
        // Check if the input is a number and satisfies the condition (0 or > 999)
        if (!isNaN(num) && (num === 0 || num > 999)) {
            return true;
        } else {
            return false;
        }
    };


    const handleProcessRowUpdate = (newRow, oldRow) => {
    
       let newAmount = 0;
       let isValid = true;
       
       if (newRow.repGoalAmt !== oldRow.repGoalAmt){
            let sanitizedValue = newRow.repGoalAmt.toString().replace(/,/g, '');
            newRow.repGoalAmt = parseFloat(sanitizedValue);
            isValid = (isValidAmount(newRow.repGoalAmt));
            if(isValid)
            {
                newAmount =   Math.round(newRow.repGoalAmt / 1000) * 1000;
                const denom = Number(newRow.priorProjected) || 0;
                newRow.rep_Growth_PCT = denom === 0 ? 0 : Math.round(((newAmount - denom) / denom) * 100);
                newRow.repGoalAmt = newAmount;
            }
                
       }
       else if(newRow.rep_Growth_PCT !== oldRow.rep_Growth_PCT) {
            const parsedPct = typeof newRow.rep_Growth_PCT === 'string'
                ? parseFloat(newRow.rep_Growth_PCT.replace(/%/g, ''))
                : Number(newRow.rep_Growth_PCT);
            newRow.rep_Growth_PCT = Number.isFinite(parsedPct) ? parsedPct : 0;
            let currentYrProjection = parseFloat(newRow.priorProjected);
            let nextYearGrowthPct = parseFloat(newRow.rep_Growth_PCT);
            newRow.repGoalAmt = Math.round((currentYrProjection * (1 + nextYearGrowthPct / 100)/100))*100;
            newAmount = Math.round(newRow.repGoalAmt / 1000) * 1000;
            isValid= newAmount !== 0 &&  newAmount > 999;
         
       }

       if (newRow.rsdGoalAmt !== oldRow.rsdGoalAmt){
            let sanitizedValue = newRow.rsdGoalAmt.toString().replace(/,/g, '');
            newRow.rsdGoalAmt = parseFloat(sanitizedValue);        
            isValid = (isValidAmount(newRow.rsdGoalAmt));
            if(isValid){
                newAmount = Math.round(newRow.rsdGoalAmt / 1000) * 1000;  
                const denom = Number(newRow.priorProjected) || 0;
                newRow.rsD_Growth_PCT = denom === 0 ? 0 : Math.round(((newAmount - denom) / denom) * 100);
                newRow.rsdGoalAmt = newAmount;
            }
             
       }
       else if(newRow.rsD_Growth_PCT !== oldRow.rsD_Growth_PCT) {
            const parsedPct = typeof newRow.rsD_Growth_PCT === 'string'
                ? parseFloat(newRow.rsD_Growth_PCT.replace(/%/g, ''))
                : Number(newRow.rsD_Growth_PCT);
            newRow.rsD_Growth_PCT = Number.isFinite(parsedPct) ? parsedPct : 0;    
            let currentYrProjection = parseFloat(newRow.priorProjected);
            let nextYearGrowthPct = parseFloat(newRow.rsD_Growth_PCT);
            newRow.rsdGoalAmt = Math.round((currentYrProjection * (1 + nextYearGrowthPct / 100)/100))*100;
            newAmount =   newRow.rsdGoalAmt 
            isValid= isValidAmount(newAmount);
       }

       if (newRow.finalGoalAmt !== oldRow.finalGoalAmt){
         
            let sanitizedValue = newRow.finalGoalAmt.toString().replace(/,/g, '');
            newRow.finalGoalAmt = parseFloat(sanitizedValue);        
            isValid = (isValidAmount(newRow.finalGoalAmt));
            if(isValid){
                newAmount = Math.round(newRow.finalGoalAmt / 1000) * 1000; 
                const denom = Number(newRow.priorProjected) || 0;
                newRow.final_Growth_PCT = denom === 0 ? 0 : Math.round(((newAmount - denom) / denom) * 100);
                newRow.finalGoalAmt = newAmount;
            }
           
    
        }
        else if(newRow.final_Growth_PCT !== oldRow.final_Growth_PCT) {
            const parsedPct = typeof newRow.final_Growth_PCT === 'string'
                ? parseFloat(newRow.final_Growth_PCT.replace(/%/g, ''))
                : Number(newRow.final_Growth_PCT);
            newRow.final_Growth_PCT = Number.isFinite(parsedPct) ? parsedPct : 0;   
            const currentYrProjection = parseFloat(newRow.priorProjected);
            const nextYearGrowthPct = parseFloat(newRow.final_Growth_PCT);
            newRow.finalGoalAmt = Math.round((currentYrProjection * (1 + nextYearGrowthPct / 100)/100))*100;
            newAmount = newRow.finalGoalAmt;
            isValid = isValidAmount(newAmount);
        }
        
       if(isValid){
            updateTotals(newAmount, newRow);
            toast.success("Goal Amount was saved.");
            return newRow;
       }
        else
        {
            toast.error("Goal Amount must be 0 or greater than 1000.Check the Growth Percentage used.");
            return oldRow;
        }
            

    };
 

    if (!goalsDetails || goalsDetails.length === 0) {
        return (<div>Loading...</div>);
    }


    return (
        
        <div className="tables">
        {
           isLoading && (
                <CircularProgress size="30px" /> )
        }

         {
                distinctBrands && (
                <div className='manageGoals'>
                    <div className='filters'>
                        <Box>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedBrand}
                                label="Brand"
                                onChange={(e) => 
                                    setFilteredData(filterBrand(e.target.value))}
                            >
                                <MenuItem value="ALL BRANDS" selected>All BRANDS</MenuItem>
                                { distinctBrands && distinctBrands.map((d,key) => <MenuItem key={key} value={d}>{d}</MenuItem>)}
            
                            </Select>
                        </Box>
                        
                        <Box>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedCategory}
                                label="Category"
                                onChange={(e) => setFilteredData(filterCategory(e.target.value))}
                            >
                                <MenuItem value="ALL CATEGORIES" selected>All CATEGORIES</MenuItem>
                                { distinctCategories && distinctCategories.map((c,key) => <MenuItem key={key} value={c}>{c}</MenuItem>)}
            
                            </Select>
                        </Box>            
                        
                        <Box>
                        {/* <ConsoleLog   status={status} salesGoalID={salesGoalID}/>  */}
                        {
                            status === "LK1" && salesGoalID && salesGoalID.length > 0 && (
                            <ProgressBar bgcolor="#3598DB" completed={progress} />
                            )
                        }
                        
                        {/* <ConsoleLog editView={editView} status={status} role={role}/> */}

                        { editView && (
                            <div className="instructions highlightYellow">Double click into a cell to edit.<br />Values will be rounded to nearest thousand.</div>
                            )
                        }

                        </Box>
                        
                        

                                
                    </div>
                    <div className='btnCol'>
                        {
                            goalsDetails && (
                                <ButtonSection status={status} 
                                    isCompleted={progress===100}
                                    progress={progress}
                                    role={role}
                                    salesGoalID={salesGoalID}
                                    btnLockClick={handleLockClick} 
                                    btnUnLockClick={handleUnlockClick} 
                                    btnSaveNoteClick={handleSaveNoteClick}
                                    btnExportClick={handleExportClick} />
                            )
                        
                        }
                    </div>
                 
                </div>
                )
            }
            <div className='goalsTable' ref={gridContainerRef}>
                <DataGridPro columns={columns} 
                 apiRef={apiRef}
                 getRowId={(row) => `${row.salesGoalID}|${row.brand}|${row.category}`}
                 columnVisibilityModel={{
                    // Hide columns status and traderName, the other columns will remain visible
                     
                    updatedCount: salesGoalID.length > 0,
                  }}
                    componentsProps={{
                    columnHeaders: {
                        sx: {
                        '& .MuiDataGrid-columnHeader': {
                            fontWeight: 'bold',
                        },
                        },
                    },
                    }}
            
                    rows={filteredData.filter(r=>r.brand.trim() !== "")}  
                        getRowClassName={(params) => {
                        if(params.row.brand.trim() === "SUB-TOTAL")
                            return 'subShadedRow';
                        else return 'nothing';
                        }}
                    isCellEditable={(params) =>  params.row.brand.trim() !== "SUB-TOTAL"}
                    
                    processRowUpdate={handleProcessRowUpdate}
                    onProcessRowUpdateError={(error) => console.log(error)}
                    
                />  

            </div>
           
        </div>
    );

  

}

const ButtonSection = ({status, isCompleted,progress, role,  salesGoalID,   btnLockClick, btnUnLockClick, btnSaveNoteClick, btnExportClick}) =>{
    const { roleLevels, goalStatus} = useContext(GlobalContext);
    const [showLockDialog, setLockDialog] = useState(false);
    const [showNoteDialog, setNoteDialog] = useState(false);
    const [showBtnType, setShowBtnType] = useState("");
    const [allowNotes, setAllowNotes] = useState(false);

    const lockSalesGoal = (lockType) =>
    {
            setLockDialog(false);
            if(lockType ==="lock")
                btnLockClick();
            else
                btnUnLockClick();

                setShowBtnType("");
    }
            
    const closeLockDialog = () =>
    {
        setLockDialog(false);
    }

 

    const saveSendNote = (note) =>
    {

         if(note && note.length > 0 ) 
         { 
            setShowBtnType("");
            btnSaveNoteClick(note);
            toast.success("Note has been sent. Sales Goal has been reverted back a level.");
         }
         setNoteDialog(false);
    }

    const closeNoteDialog = () =>
    {
        setNoteDialog(false);
    }

    useEffect(() => {
        setShowBtnType("");
        setAllowNotes(false);

        if(salesGoalID === "")
        {
            setShowBtnType("");
            setAllowNotes(false);
        }
        else {
            if((status === goalStatus.Level2 && role === roleLevels.Level2) || (status === goalStatus.Level3 && role === roleLevels.Level3))
                setAllowNotes(true);
            
    
            if(status === goalStatus.Level4 && role === roleLevels.Level3)
                setShowBtnType("SetBackToLevel3");
            else if(status === goalStatus.Level3 && role === roleLevels.Level3 )
               setShowBtnType("Finalize");
            else if(status !== goalStatus.Level4 && role !== roleLevels.Level3)
            {
                
                if((status === goalStatus.Level1 && role === roleLevels.Level1 && isCompleted) || (status === goalStatus.Level2 && role === roleLevels.Level2))
                    setShowBtnType("Submit");
                else
                     setShowBtnType("");
            }
        }
        

    },[status,isCompleted])


    return(
        <React.Fragment>
                <Box>
                    <Button className="lockBtn green" onClick={btnExportClick}><FontAwesomeIcon icon={faFileExcel} title="Export to Excel" size="lg" className="addpadding"/>Export</Button>
                </Box>
                
                    {/* <ConsoleLog showBtnType={showBtnType} allowNotes={allowNotes} /> */}
                       
                    
                    {showBtnType === "SetBackToLevel3"
                        && (
                            <Button className="lockBtn" onClick={ (e) => {
                                setLockDialog(true);
                            }}>
                                <FontAwesomeIcon icon={faTableCellsRowUnlock} title="Unlock Back to Level 3" size="lg" className="addpadding"></FontAwesomeIcon>Unlock 
                            </Button>
                        )
                    }

                    {
                        allowNotes  && (
                            <Box>
                                <Button className="lockBtn" onClick={ (e) => {
                                setNoteDialog(true);
                            }   }>
                                    <FontAwesomeIcon icon={faEnvelope} title="Send Note and Push Back" size="lg" className="addpadding"/>
                                    Note
                                </Button>
                            </Box>
                            
                        )
                    }
                     

                    {
                        showBtnType === "Finalize" && (
                            <Box>
                                <Button className="lockBtn" 
                                    onClick={ (e) => {
                                    setLockDialog(true);
                                }}>
                                <FontAwesomeIcon icon={faCheck} title= "Finalize" size="lg" className="addpadding"/> Finalize
                                </Button>

                            </Box>
                            

                        )
                    }

                    {
                        showBtnType === "Submit"  && (
                            <Box>
                                <Button className="lockBtn" 
                                    onClick={ (e) => {
                                    setLockDialog(true);
                                }}>
                                    <FontAwesomeIcon icon={faCheck} title= "Submit and Pass to Next Level" size="lg" className="addpadding"/> Submit
                                </Button>
                            </Box>
                         )
                    }
                    <LockDialog open={showLockDialog} lockType={showBtnType === "SetBackToLevel3" ? "unlock" : "lock"} onConfirm={lockSalesGoal} onClose={closeLockDialog} />
                    <NoteDialog open={showNoteDialog} salesGoalID={salesGoalID} onConfirm={saveSendNote} onClose={closeNoteDialog} />
              
     
            
            
        
        </React.Fragment>
        
    );

    
}


export default GoalsDataGrid;